export default "__VITE_ASSET__11aed11d__"